"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationTransferCreateRequest = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const query_1 = __importDefault(require("./query"));
const mutation = (0, graphql_tag_1.default) `
  mutation OrganizationTransferCreateRequest(
    $organization: ID!
    $fromWorkspace: ID!
    $toWorkspace: ID!
    $data: ShiftData
    $shiftId: ID
    $autoApprove: Boolean
  ) {
    organizationTransferCreateRequest(
      organization: $organization
      fromWorkspace: $fromWorkspace
      toWorkspace: $toWorkspace
      shiftId: $shiftId
      data: $data
      autoApprove: $autoApprove
    ) {
      ${query_1.default.TRANSFER_DETAILS_PARAMS}
    }
  }
`;
const organizationTransferCreateRequest = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(mutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors, (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.error')));
    return data?.organizationTransferCreateRequest;
};
exports.organizationTransferCreateRequest = organizationTransferCreateRequest;
